<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2 5.5C2 4.7 2.7 4 3.5 4H19.5C20.3 4 21 4.7 21 5.5C21 6.3 20.3 7 19.5 7H3.5C2.7 7 2 6.3 2 5.5ZM2 11.5C2 10.7 2.7 10 3.5 10H12.5C13.3 10 14 10.7 14 11.5C14 12.3 13.3 13 12.5 13H3.5C2.7 13 2 12.3 2 11.5ZM2 17.5C2 16.7 2.7 16 3.5 16H17.5C18.3 16 19 16.7 19 17.5C19 18.3 18.3 19 17.5 19H3.5C2.7 19 2 18.3 2 17.5Z"
		fill="currentColor" />
</svg>
	